<template>
  <v-layout wrap align-center :style="listerStyle">
    <v-flex xs12 v-show="!hideSearchbar">
      <v-layout wrap>
          <v-text-field
            :label="searchLabel"
            :style="searchTextFieldStyle"
            v-model="internalSearchString"
            :hide-details="'auto'"
            :error-messages="searchErrorMessage"
            :prepend-icon="'search'"
            :single-line="!searchLabel"
            class="mb-8"
            :placeholder="searchPlaceholder || 'Buscar'"
          ></v-text-field>
      </v-layout>
    </v-flex>
    <transition-group
      v-show="!showPlaceholder"
      name="list-complete"
      tag="div"
      style="height: 100%; overflow: hidden"
      class="layout align-start wrap sortableContainer"
    >
      <v-flex class="sortable" v-for="(item, index) in shownItems" :key="item.id || index" :class="cardBreakpoints || 'xs12'">
        <slot @click="$emit('click', $event)" v-bind:item="item" v-bind:index="index"></slot>
      </v-flex>
    </transition-group>
    <template v-if="searching">
      <v-layout wrap column align-center justify-center fill-height v-show="showPlaceholder">
        <v-spacer />
        <v-flex xs1>
          <v-icon large class="text-xs-center mt-2">search</v-icon>
        </v-flex>
        <v-flex xs6>
          <h4
            class="text-xs-center mt-2"
            style="color: #888888"
          >{{emptySearchMessage || 'Nenhum item encontrado...'}}</h4>
        </v-flex>
      </v-layout>
    </template>
    <template v-else>
      <v-layout wrap column align-center justify-center fill-height v-show="showPlaceholder">
        <v-spacer />
        <v-flex xs1 v-if="emptyListIcon">
          <v-icon large class="text-xs-center mt-2">{{emptyListIcon || 'close'}}</v-icon>
        </v-flex>
        <v-flex xs6>
          <h4
            class="text-xs-center mt-2 "
            style="color: #888888"
          >{{emptyListMessage || 'Nenhum item cadastrado...'}}</h4>
        </v-flex>
      </v-layout>
    </template>
    <template v-if="showPagination">
      <v-pagination class="mt-5" v-model="currentPage" :length="numberOfPages" />
    </template>
  </v-layout>
</template>

<script>
export default {
  name: 'Lister',
  data: () => ({
    originalItems: [],
    currentPage: 1,
    internalSearchString: '',
  }),
  props: {
    items: Array,
    searchLabel: String,
    listerStyle: String,
    searchTextFieldStyle: String,
    cardBreakpoints: String,
    emptyListIcon: String,
    emptyListMessage: String,
    emptySearchMessage: String,
    searchPlaceholder: String,
    searchErrorMessage: String,
    customSearchFunction: Function,
    customSortFunction: Function,
    searchText: String,
    hideSearchbar: { type: Boolean, default: false },
    reorderable: { type: Boolean, default: false },
    autosort: { type: Boolean, default: true },
    paginated: { type: Boolean, default: false },
    pages: {
      type: Object,
      default: () => ({
        xs: 4, sm: 5, md: 6, lg: 10, xl: 12,
      }),
    },
  },
  computed: {
    itemsAreDefined() {
      return this.items ? true : false
    },
    receivedItems() {
      return this.itemsAreDefined ? this.$props.items: [] ;
    },
    pageSize() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return this.pages.xs;
        case 'sm': return this.pages.sm;
        case 'md': return this.pages.md;
        case 'lg': return this.pages.lg;
        case 'xl': return this.pages.xl;
        default: return this.pages.xs;
      }
    },
    showPagination() {
      return this.paginated && !this.searching && this.numberOfPages > 1;
    },
    numberOfPages() {
      const quocient = Math.floor((this.itemsAreDefined ? this.items: []).length / this.pageSize);
      if (this.lastPageSize === 0) {
        return quocient;
      }
      return quocient + 1;
    },
    lastPageSize() {
      return (this.itemsAreDefined ? this.items: []).length % this.pageSize;
    },
    receivedSearchString() {
      return this.$props.searchText;
    },
    searchString() {
      if (this.$props.hideSearchbar) {
        return this.receivedSearchString;
      }
      return this.internalSearchString;
    },
    showPlaceholder() {
      return this.shownItems.length === 0;
    },
    searching() {
      if (this.$props.hideSearchbar) {
        return this.receivedSearchString !== '';
      }
      return this.searchString !== '';
    },
    shownItems() {
      const filteredItems = (this.itemsAreDefined ? this.originalItems : []).filter((item) => {
        if (this.hideSearchbar){
          return true
        }
        if (this.customSearchFunction) {
          return this.customSearchFunction(item, this.searchString);
        }
        const title = item.title || item;
        return title
          .toLowerCase()
          .includes(this.searchString.toLowerCase());
      });
      if (!this.searching && this.paginated) {
        const initialIndex = (this.currentPage - 1) * this.pageSize;
        if (this.currentPage > 1 && this.currentPage === this.numberOfPages) {
          return filteredItems.slice(initialIndex, initialIndex + this.lastPageSize);
        }
        return filteredItems.slice(initialIndex, initialIndex + this.pageSize);
      }
      return filteredItems;
    },
  },
  methods: {
    sort(a, b) {
      return (`${a.title || a}`).localeCompare(b.title || b);
    },
  },
  watch: {
    items: {
      immediate: true,
      handler(newItems) {
        const vm = this;
        vm.originalItems = newItems.slice();
        if (vm.customSortFunction){
          vm.originalItems.sort(vm.customSortFunction);
        }
        else if (vm.autosort){
          vm.originalItems.sort(vm.sort);
        }
      },
    },
  },
};
</script>

<style>
.list-complete-enter,
.list-complete-leave-active {
  opacity: 0;
}
.list-complete-move {
  transition: transform 0.5s;
}
.list-complete-item {
  transition: all 0.5s;
}
.list-complete-enter-active,
.list-complete-leave-active {
  transition-property: all;
  transition-duration: 0.5s;
}
.list-complete-leave-active {
  position: absolute;
}
</style>
